module.exports = __webpack_public_path__ + "static/media/unread.2867a77e.svg";